var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app-root"}},[(_vm.isStaging)?_c('div',{staticClass:"staging-banner"},[_vm._v(" STAGING ENVIRONMENT ")]):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }